import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../services/state.service'
@Component({
  selector: 'app-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})

export class DefaultLayoutComponent implements OnInit {
  
  loading = false;
  isShowAlert = false;
  language;
  alertDetail = {
    "title": "",
    "message": "",
    "successText": "",
    "cancelText": "",
    "isShowIcon": "",
    "showConfirmBtn": true
    
  };
  successAction = ()=>{this.closeAlert()};
  cancelAction = ()=>{this.closeAlert()};
  
  constructor(
    private state: StateService
  ) {
    this.language = state.language;
  }

  ngOnInit() {
  }

  isLoading(loading){
    this.loading = loading;
  }

  showAlert(title = "", message = "", successText = "", successAction = null, cancelText = "", cancelAction = null, isShowIcon = "", showConfirmBtn = true){
    this.alertDetail = {
      "title": title,
      "message": message,
      "successText": successText,
      "cancelText": cancelText,
      "isShowIcon": isShowIcon,
      "showConfirmBtn": showConfirmBtn
    }
    if(successAction != null){
      this.successAction = successAction;
    }else{
      this.successAction = this.onClickOk;
    }

    if(cancelAction != null){
      this.cancelAction = cancelAction;
    }else{
      this.cancelAction = this.onClickOk;
    }
    this.isShowAlert = true; 
  }

  closeAlert(){
    this.isShowAlert = false;
  }

  onClickOk = () =>{
    this.isShowAlert = false;
  }


}
